
define('template!headerDesignersView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="title">' +
((__t = ( _.i18n('order.header.designers.title') )) == null ? '' : __t) +
'</div>      \n<div class="users-container"></div>\n<div class="empty">' +
((__t = ( _.i18n('order.header.designers.empty') )) == null ? '' : __t) +
'</div>';

}
return __p
};});

